<template>
  <div class="root">
    <h2 class="text-center">Users game permission</h2>
    <UsersTable />
  </div>
</template>

<script>
import UsersTable from "./UsersTable";

export default {
  name: "GamesPermissionComponent",
  components: {
    UsersTable
  }
};
</script>

<style scoped>
.root {
  height: auto;
  font-family: Montserrat !important;
}
</style>
